// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2291":"3bcff8db","8999":"3bcff8db"}[chunkId] + ".chunk.css";
};